import { initializeApp } from 'firebase/app'
import ElElements from 'vue-el-element'

// Initialize Firebase
let config = {
  apiKey: 'AIzaSyCS28HoKid9O1zwZRQ0nYbB_3NOG0kpR44',
  authDomain: 'equardian.firebaseapp.com',
  databaseURL: 'https://equardian.firebaseio.com',
  projectId: 'equardian',
  storageBucket: 'equardian.appspot.com',
  messagingSenderId: '460310477362',
  appId: '1:460310477362:web:ae9ec1bdb0e28cc82ada2b',
}

const firebaseApp = initializeApp(config)

global.firebaseApp = firebaseApp

export default (Vue) => {
  Object.entries(ElElements)
    .forEach(([type, ElElement]) => {
      Vue.component(type, ElElement)
    })
}
